import { render, staticRenderFns } from "./PlaceOrderSuccess.vue?vue&type=template&id=6e5696cc&scoped=true"
import script from "./PlaceOrderSuccess.vue?vue&type=script&lang=js"
export * from "./PlaceOrderSuccess.vue?vue&type=script&lang=js"
import style0 from "./PlaceOrderSuccess.vue?vue&type=style&index=0&id=6e5696cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5696cc",
  null
  
)

export default component.exports